import Vue from 'vue'
import store from '../store'

export default {
  userHasRole (roles) {
    let hasRole = false
    Vue._.forEach(roles, function (role) {
      if (store.getters['security/hasRole'](role)) {
        hasRole = true
      }
    })
    return hasRole
  },
  userHasAllRoles (roles) {
    let hasAllRoles = true
    Vue._.forEach(roles, function (role) {
      if (!store.getters['security/hasRole'](role)) {
        hasAllRoles = false
      }
    })
    return hasAllRoles
  },
  isPrivilegedUser () {
    return store.getters['security/hasRole']('ROLE_ADMIN') || store.getters['security/hasRole']('ROLE_SUPER_ADMIN')
  },
  userHasNotRole (roles) {
    let hasnotRole = true
    Vue._.forEach(roles, function (role) {
      if (store.getters['security/hasRole'](role)) {
        hasnotRole = false
      }
    })
    return hasnotRole
  }
}
